import { ListItem, Switch } from '@rneui/themed'
import React from 'react'

interface BooleanProps {
  title: string
  value: boolean
  onToggle(): void
  disabled?: boolean
}

export function BooleanRow({ onToggle, title, value, disabled }: BooleanProps) {
  return (
    <ListItem containerStyle={{ paddingVertical: 0 }}>
      <ListItem.Content>
        <ListItem.Title>{title}</ListItem.Title>
      </ListItem.Content>
      <ListItem.Content right>
        <Switch
          style={{ alignSelf: 'flex-end' }}
          value={value}
          onValueChange={onToggle}
          disabled={disabled}
        />
      </ListItem.Content>
    </ListItem>
  )
}
